import { render, staticRenderFns } from "./AppAnnotationAssessmentReport.vue?vue&type=template&id=77b28e84&scoped=true"
import script from "./AppAnnotationAssessmentReport.vue?vue&type=script&lang=ts"
export * from "./AppAnnotationAssessmentReport.vue?vue&type=script&lang=ts"
import style0 from "./AppAnnotationAssessmentReport.vue?vue&type=style&index=0&id=77b28e84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77b28e84",
  null
  
)

export default component.exports